<header class="flex items-center justify-between p-4 font-medium">
    <div class="cursor-pointer flex items-center" routerLink="/">
        <img src="assets/primary-logo.svg" alt="Logo" class="h-8 mr-4"/>
        <h1 class="text-xl text-gray-800">xCF</h1>
    </div>

    @if (!isAuthLoading()) {

        @if (user()) {
            <div class="flex items-center w-full">
                <div class="flex-1"></div>
                <button mat-button
                        [matMenuTriggerFor]="userMenu"
                        class="flex items-center">
                    <div class="flex items-center">
                    <span class="flex items-center">
                        <img [src]="user()?.picture" [alt]="user()?.name" class="w-8 h-8 rounded-full mr-2"/>
                        <span class="text-gray-800">{{ user()?.name }}</span>
                    </span>
                        <mat-icon class="ml-1">keyboard_arrow_down</mat-icon>
                    </div>
                </button>
            </div>

            <mat-menu #userMenu="matMenu"
                      xPosition="before"
                      yPosition="below"
                      [overlapTrigger]="false">
                <button mat-menu-item (click)="onGoToOverview()">
                    <mat-icon>arrow_outward</mat-icon>
                    <span>Apps Overview</span>
                </button>
                <button mat-menu-item (click)="onLogout()">
                    <mat-icon>logout</mat-icon>
                    <span>Logout</span>
                </button>
            </mat-menu>

        } @else {
            <button mat-button (click)="onLogin()">Login</button>
        }

    }

</header>
